<p-tabView #primeTabMenu 
           [orientation]="orientation"
           (onChange)="onTabChange($event)">

    <ng-content></ng-content>

</p-tabView>